import { useEffect, useState } from "react";
import { Cpu, Search } from "react-feather";
import { toast } from "react-toastify";
import {
  filterOracleProcessQueue,
  immediateOracleIntegration,
} from "../../api/finance/oracleProcessQueueApi";
import { getBulkDropdownData } from "../../api/keyvalue";
import Grid from "../../components/Grid";
import Button from "../../components/input/Button";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import LoadingSpinner from "../../components/LoadingSpinner";
import ButtonRenderer from "../../components/renderer/ButtonRenderer";
import { ResizableScrollingTextRenderer } from "../../components/renderer/StyleRenderer";
import { formatFromJsonDate } from "../../dateConfig";
import useUserCompany from "../../hooks/useUserCompany";

const OracleProcessQueue = () => {
  const userCompany = useUserCompany();
  const [tab, setTab] = useState(1);
  const [activeAccordion, setActiveAccordion] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [processType, setProcessType] = useState(1);
  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null
  );
  const [isIntegrating, setIsIntegrating] = useState(false);
  const [searching, setSearching] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [searchRes, setSearchRes] = useState([]);
  const [integrationTypeOptions, setIntegrationTypeOptions] = useState([]);
  const [dropdownValuesLoading, setDropdownValuesLoading] = useState(false);
  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);
  const [code, setCode] = useState("");

  const handleAccordionClick = (index) => {
    setActiveAccordion(index === activeAccordion ? null : index);
  };

  useEffect(() => {
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 7);
    const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
    const formattedToday = new Date().toISOString().split("T")[0];
    setFromDate(formattedWeekAgo);
    setToDate(formattedToday);
  }, []);

  const handleSearch = async () => {
    try {
      handleAccordionClick(2);
      setSearching(true);
      setSearchClicked(true);
      const searchResponse = await filterOracleProcessQueue({
        fromDate: fromDate,
        toDate: toDate,
        company: company,
        processType: processType,
      });

      let mappedResponse = [];
      for (let res of searchResponse) {
        mappedResponse.push({
          ...res,
          createdBy: res.createdBy ? res.createdBy : "N/A",
          // createdDate: res.createdDate ? res.createdDate.split("T")[0] : "N/A",
          createdDate: res.createdDate
            ? formatFromJsonDate(res.createdDate)
            : "N/A",
          processType: res.processType ? res.processType : "N/A",
          lastModifiedBy: res.lastModifiedBy ? res.lastModifiedBy : "N/A",
          lastModifiedDate: res.lastModifiedDate
            ? formatFromJsonDate(res.lastModifiedDate)
            : "N/A",
          errorLog: res.errorLog ? res.errorLog : "N/A",
        });
      }
      setSearchRes(mappedResponse);
      setSearching(false);
    } catch (e) {
      console.log(e);
    }
  };

  const handleReset = () => {
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 7);
    const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
    const formattedToday = new Date().toISOString().split("T")[0];
    setFromDate(formattedWeekAgo);
    setToDate(formattedToday);
    setProcessType(1);
    setSearchClicked(false);
  };

  useEffect(() => {
    (async () => {
      setDropdownValuesLoading(true);

      const { integration_queue_type: integrationTypeOpt } =
        await getBulkDropdownData([{ key: "integration_queue_type" }]);

      setIntegrationTypeOptions(integrationTypeOpt);
      setDropdownValuesLoading(false);
    })();
  }, []);

  console.log("Integration Type Options", integrationTypeOptions);

  return (
    <>
      {isIntegrating && (
        <div className="blur-overlay">
          <LoadingSpinner message={`Integrating ${code}...`} />
        </div>
      )}

      <div className="ui tabular menu top attached">
        <div
          className={`item ${tab === 1 ? "active" : ""}`}
          onClick={() => {
            setTab(1);
          }}
        >
          <span>
            <Cpu size={15} style={{ marginRight: "5px" }} />
          </span>
          Oracle Process Queue
        </div>
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion === 1 ? "active" : ""}`}
            onClick={() => handleAccordionClick(1)}
          >
            <div>
              Search
              <Search size={14} style={{ marginLeft: "10px" }} />
              <i className="dropdown icon"></i>
            </div>
          </div>
          <div className={`content ${activeAccordion === 1 ? "active" : ""}`}>
            <>
              {dropdownValuesLoading ? (
                <LoadingSpinner />
              ) : (
                <form className="ui form">
                  <div className="three fields">
                    <Input
                      type={"date"}
                      label={"From Date"}
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                    <Input
                      type={"date"}
                      label={"To Date"}
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                    <Dropdown
                      options={integrationTypeOptions}
                      label={"Process Type"}
                      value={processType}
                      onChange={(e, data) => setProcessType(data.value)}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div className="field" style={{ width: "100%" }}>
                      <Button template="search" onClick={handleSearch} />
                      <Button template="searchReset" onClick={handleReset} />
                    </div>
                  </div>
                </form>
              )}
            </>
          </div>
        </div>
        {searchClicked && (
          <>
            {searching ? (
              <LoadingSpinner />
            ) : (
              <Grid
                content={searchRes}
                isLoading={searching}
                config={[
                  {
                    headerName: "Code",
                    field: "evinvOrCreditdebitNumber",
                    pinned: "left",
                    filter: true,
                    cellStyle: (param) => ({
                      backgroundColor:
                        param.data.processType === 1
                          ? "#bceebbff"
                          : param.data.processType === 2
                            ? "#f6e972ff"
                            : "#f0afafff",
                    }),
                  },
                  {
                    headerName: "Process Type",
                    field: "processTypeName",
                    cellRenderer: ResizableScrollingTextRenderer,
                    filter: true,
                    cellStyle: (param) => ({
                      backgroundColor:
                        param.data.processType === 1
                          ? "#bceebbff"
                          : param.data.processType === 2
                            ? "#f6e972ff"
                            : "#f0afafff",
                    }),
                  },
                  {
                    headerName: "Created Date",
                    field: "createdDate",
                    cellRenderer: ResizableScrollingTextRenderer,
                    filter: true,
                    cellStyle: (param) => ({
                      backgroundColor:
                        param.data.processType === 1
                          ? "#bceebbff"
                          : param.data.processType === 2
                            ? "#f6e972ff"
                            : "#f0afafff",
                    }),
                  },
                  {
                    headerName: "Created By",
                    field: "createdBy",
                    cellRenderer: ResizableScrollingTextRenderer,
                    filter: true,
                    cellStyle: (param) => ({
                      backgroundColor:
                        param.data.processType === 1
                          ? "#bceebbff"
                          : param.data.processType === 2
                            ? "#f6e972ff"
                            : "#f0afafff",
                    }),
                  },
                  {
                    headerName: "Last Modified Date",
                    field: "lastModifiedDate",
                    cellRenderer: ResizableScrollingTextRenderer,
                    filter: true,
                    cellStyle: (param) => ({
                      backgroundColor:
                        param.data.processType === 1
                          ? "#bceebbff"
                          : param.data.processType === 2
                            ? "#f6e972ff"
                            : "#f0afafff",
                    }),
                  },
                  {
                    headerName: "Last Modified By",
                    field: "lastModifiedBy",
                    cellRenderer: ResizableScrollingTextRenderer,
                    filter: true,
                    cellStyle: (param) => ({
                      backgroundColor:
                        param.data.processType === 1
                          ? "#bceebbff"
                          : param.data.processType === 2
                            ? "#f6e972ff"
                            : "#f0afafff",
                    }),
                  },
                  {
                    headerName: "Error Log",
                    field: "errorLog",
                    cellRenderer: ResizableScrollingTextRenderer,
                    filter: true,
                    pinned: "right",
                    cellStyle: (param) => ({
                      backgroundColor:
                        param.data.processType === 1
                          ? "#bceebbff"
                          : param.data.processType === 2
                            ? "#f6e972ff"
                            : "#f0afafff",
                    }),
                  },
                  {
                    field: "Integrate",
                    cellRenderer: ButtonRenderer,
                    pinned: "right",
                    width: "60",
                    minWidth: "60",
                    cellRendererParams: (params) => {
                      return {
                        clickHandler: async () => {
                          setIsIntegrating(true);
                          try {
                            console.log("Integrate", params.data);
                            setCode(params.data.evinvOrCreditdebitNumber);
                            const res = await immediateOracleIntegration({
                              processType: params.data.processType,
                              code: params.data.evinvOrCreditdebitNumber,
                            });
                            console.log("res", res);

                            if (!res) {
                              toast.error("No response received", {
                                containerId: "Main",
                              });
                              return;
                            }
                            switch (res.status) {
                              case 200:
                                toast.success(res.data, {
                                  containerId: "Main",
                                });
                                break;
                              case 400:
                                toast.warn(res.data, {
                                  containerId: "Main",
                                });
                                break;
                              case 500:
                                toast.error(res.data, {
                                  containerId: "Main",
                                });
                                break;
                              default:
                                toast.error(`Unexpected error: ${res.data}`, {
                                  containerId: "Main",
                                });
                            }
                          } catch (e) {
                            toast.error("Network error.Try again..", {
                              autoClose: 5000,
                              containerId: "Main",
                            });
                            setIsIntegrating(false);
                          } finally {
                            setIsIntegrating(false);
                          }

                          setIsIntegrating(false);
                        },
                        // label: "Integrate",
                        Icon: Cpu,
                        className: `ui ${params.data.processType === 1 ? "#bceebbff" : params.data.processType === 2 ? "#f6e972ff" : "#f0afafff"} button`,
                        disabled:
                          !params.data.processType ||
                          !params.data.evinvOrCreditdebitNumber,
                      };
                    },
                  },
                ]}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default OracleProcessQueue;

const styles = `
  .blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 9999; /* Ensure it's on top of everything */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blurred {
    filter: blur(5px); /* Blur effect on content */
    pointer-events: none; /* Prevent interaction with blurred content */
  }
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
